module.exports = __webpack_public_path__ + "static/assets/3ee3113aa5fee97085b5e7c873cc59f7.svg";